module.exports = __webpack_public_path__ + "img/1.6d22baa3.jpg";